import {Injectable} from '@angular/core';

@Injectable( { providedIn: 'root' } )
export class SessionStorageService {
  constructor() {}

  setSavedState(state: any, localStorageKey: string) {
    sessionStorage.setItem(localStorageKey, JSON.stringify(state));
  }

  getSavedState(localStorageKey: string): any {
    return JSON.parse(sessionStorage.getItem(localStorageKey));
  }
}
